import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

// export function fShortenNumber(number) {
//   // if(number!==null && number!==undefined)
//   //   return replace(numeral(number).format('0.00a'), '.00', '');

// /* eslint-disable */

// if (number !== null && number !== undefined) {
//   if (number >= 10000000) {
//     const crore = Math.floor(number / 10000000);
//     const remaining = number % 10000000;
//     const lakh = Math.floor(remaining / 100000);
//     const thousand = Math.floor((remaining % 100000) / 1000);
//     let formattedNumber = `${crore} Cr`;
//     if (lakh > 0) {
//      // formattedNumber += ` ${lakh} L`;
//       return `${crore}.${lakh} Cr`
//     }
//     // if (thousand > 0) {
//     //   formattedNumber += ` ${thousand} K`;
      
//     // }

//     return formattedNumber
  

//   } else if (number >= 100000) {
//     const lakh = Math.floor(number / 100000);
//     const remaining = number % 100000;
//     const thousand = Math.floor(remaining / 1000);
//     let formattedNumber = `${lakh} L`;
//     if (thousand > 0) {
//       //formattedNumber += ` ${thousand} K`;
//       return `${lakh}.${thousand} L`
//     }
//     return formattedNumber;
//   } else if (number >= 1000) {
//     const thousand = Math.floor(number / 1000);
//     const hundred = number % 1000;
//     let formattedNumber = `${thousand} K`;
//     if (hundred > 0) {
//       const h = String(hundred)?.slice(0,2)
//       return `${thousand}.${h } K`
//     }
//     return formattedNumber;

//   } else {
//     return `${number}`;
//   }
// }

// }


export function fShortenNumber(number) {
  if (number !== null && number !== undefined) {
    if (number >= 10000000) {
      // Format for crore
      const crore = Math.floor(number / 100000) / 100;
      return `${crore} Cr`;
    } if (number >= 100000) {
      // Format for lakh
      const lakh = Math.floor(number / 1000) / 100;
      return `${lakh} L`;
    }  if (number >= 1000) {
      // Format for thousand
      const thousand = Math.floor(number / 10) / 100;
      return `${thousand} K`;
    } 
      // Return the number as it is if less than 1000
      return `${number}`;
    
  }
  return "0";
}


export function fData(number) {
  return numeral(number).format('0.0 b');
}
